type StringOrUndefined = string | undefined;

export const stringJoin = (
  separator: string,
  ...strings: StringOrUndefined[]
) => {
  return strings.filter((s) => !!s).join(separator);
};
